import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "chevron-left" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M10.0001 13.3332L4.66675 7.99985L10.0001 2.6665",
        stroke: "currentColor",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }